import { useState, useMemo } from "react";
import { Switch, Route } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { YearInReviewContainer } from "@ugg/shared/components/YearInReview/YearInReviewContainer";
import { useRsoConnection } from "@ugg/shared/api/requests/accounts/oauth-hooks";
import { useLoginState } from "@ugg/shared/hooks/use-user-hooks";
import { SummonerInfo } from "@ugg/shared/hooks/use-is-year-in-review-owner";
import FeedbackForm from "components/Masthead/Feedback/FeedbackForm";

function useSummonerInfoFromUserState(): SummonerInfo | undefined {
  const { summoner, hasRsoConnection, loading: loadingRso } = useRsoConnection();
  const isLoggedIn = useLoginState();

  return useMemo(() => {
    if (!isLoggedIn || loadingRso || !hasRsoConnection || !summoner) {
      return undefined;
    }

    return {
      gameName: summoner.riotUserName,
      tagLine: summoner.riotTagLine,
      webRegion: summoner.regionId,
      isVerified: true, // RSO connection implies verified
    };
  }, [isLoggedIn, summoner, hasRsoConnection, loadingRso]);
}

export function YearInReviewPage() {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const summonerInfo = useSummonerInfoFromUserState();

  const toggleFeedbackPopup = () => {
    setFeedbackOpen(!feedbackOpen);
  };

  return (
    <>
      <Switch>
        <Route
          path={AppRoutes.PROFILE_YEAR_IN_REVIEW}
          render={() => <YearInReviewContainer onContactSupport={toggleFeedbackPopup} summonerInfo={summonerInfo} />}
        />
      </Switch>
      {feedbackOpen && <FeedbackForm toggleFeedbackPopup={toggleFeedbackPopup} />}
    </>
  );
}
